import { theme } from '@sg/garnish';

import * as PinAssets from './assets';
import { type MarkerImages } from './Map.types';

// ─── Marker ──────────────────────────────────────────────────────────────────

export const MARKER_SIZE = 48;
export const MARKER_ICON_SIZE = MARKER_SIZE / 2;

// ─── Padding ─────────────────────────────────────────────────────────────────

export const DEFAULT_EDGE_PADDING = theme.spacing['10'];
export const DEFAULT_EDGE_PADDINGS = [
  DEFAULT_EDGE_PADDING,
  DEFAULT_EDGE_PADDING,
  DEFAULT_EDGE_PADDING,
  DEFAULT_EDGE_PADDING,
];

// ─── Zoom ────────────────────────────────────────────────────────────────────

export const MAX_ZOOM_LEVEL = 17;

// ─── Assets ──────────────────────────────────────────────────────────────────

export const PIN_IMAGES = {
  'pin-customer': PinAssets.PinCustomer,
  'pin-courier': PinAssets.PinCourier,
  'pin-location': PinAssets.PinLocation,
  'pin-home': PinAssets.PinHome,
  'pin-work': PinAssets.PinWork,
  'pin-custom': PinAssets.PinCustom,
  'pin-minimized-open': PinAssets.PinMinimizedOpen,
  'pin-minimized-closed': PinAssets.PinMinimizedClosed,
  'pin-outpost': PinAssets.PinOutpost,
  'pin-outpost-closed': PinAssets.PinOutpostClosed,
  'pin-pickup-closed': PinAssets.PinPickupClosed,
  'pin-pickup': PinAssets.PinPickup,
} as const satisfies MarkerImages;

// ─── Transitions ─────────────────────────────────────────────────────────────

export const TRANSITION_DURATION_WEB = 1500;
